import { errorMessage as REQUIRED_ERROR_MESSAGE } from 'hb-react/shared/utils/validators/required';

import { isContentHtmlEmpty } from './contentHtml';
import { CONTENT_TOO_LONG_ERROR } from '../constants';

export const getContentValidator =
  ({ quillRef, isRequired, requiredErrorMessage, maxLength }) =>
  (value) => {
    // If quillRef is not set, it means that the editor is not mounted yet.
    if (!quillRef.current) {
      return;
    }

    if (isRequired && isContentHtmlEmpty(value)) {
      return requiredErrorMessage || REQUIRED_ERROR_MESSAGE;
    }

    const contentLength = quillRef.current.getLength();

    if (maxLength && contentLength > maxLength) {
      return CONTENT_TOO_LONG_ERROR.i__({
        maxLength: maxLength.toString(),
      });
    }
  };
